import { render, staticRenderFns } from "./ItemPurchaseInfoTransaction.vue?vue&type=template&id=f68075d0&scoped=true&"
import script from "./ItemPurchaseInfoTransaction.vue?vue&type=script&lang=ts&"
export * from "./ItemPurchaseInfoTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./ItemPurchaseInfoTransaction.vue?vue&type=style&index=0&id=f68075d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68075d0",
  null
  
)

export default component.exports